module.exports = __webpack_public_path__ + "static/media/ic_chevron_left_black_24px.169f5419.svg";